import { render, staticRenderFns } from "./unifiedMeal.vue?vue&type=template&id=0c568b79&scoped=true&"
import script from "./unifiedMeal.vue?vue&type=script&lang=js&"
export * from "./unifiedMeal.vue?vue&type=script&lang=js&"
import style0 from "./unifiedMeal.vue?vue&type=style&index=0&id=0c568b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c568b79",
  null
  
)

export default component.exports